var _defs, _rect, _g, _g2, _g3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHazardousIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 280",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6fdf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf7ea"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 12,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -48,
    width: 230,
    height: 64,
    rx: 8,
    fill: "#0f1724"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: -72,
    width: 140,
    height: 96,
    rx: 10,
    fill: "#1f6f3a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: -60,
    width: 100,
    height: 72,
    rx: 8,
    fill: "#92c53d",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 14,
    r: 18,
    fill: "#0b1220"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 14,
    r: 18,
    fill: "#0b1220"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 120,
    width: 40,
    height: 64,
    rx: 6,
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 120,
    width: 40,
    height: 64,
    rx: 6,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 120,
    width: 40,
    height: 64,
    rx: 6,
    fill: "#334155"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,60) scale(0.95)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "#fff3e0",
    stroke: "#ffb74d",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff8a00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6 -20 A34 34 0 0 1 26 -4 L6 20 A14 14 0 0 0 -6 -6 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 38,
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 15,
    fill: "#0b3b2b"
  }, "Handling \u2022 Transport \u2022 Compliant Disposal")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazardousIllustration);
export default __webpack_public_path__ + "static/media/hazardous-illustration.7c4122cf986109cf99917a642d3fc76c.svg";
export { ForwardRef as ReactComponent };